import React, { useState } from 'react';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { CategoryKey } from './categoryData';
type HeaderProps = {
  activeCategory: CategoryKey;
  onCategorySelect: (categoryKey: CategoryKey, subcategory?: string) => void;
  onAboutSelect: () => void;
};
type CategoryNavItem = {
  key: CategoryKey;
  label: string;
  children?: string[];
};
const CATEGORY_NAV_ITEMS: CategoryNavItem[] = [{
  key: 'alimentation',
  label: 'Alimentation',
  children: ['Huile d’Olive', 'Fruits et Légumes', 'Fruits Frais', 'Fruits secs', 'Produits Laitiers', 'Viandes et Poissons']
}, {
  key: 'boisson',
  label: 'Boisson'
}, {
  key: 'maison-decoration',
  label: 'Maison et Décoration'
}, {
  key: 'electronique',
  label: 'Électronique'
}];
function Logo() {
  return <a href="#accueil" className="flex items-center rounded-md bg-white px-2 py-1.5 shadow-sm transition-opacity hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-ardis-yellow focus:ring-offset-2 focus:ring-offset-ardis-green" aria-label="LE PIAN DISTRIBUTION — Accueil" data-id="element-249" data-mp="3baodutmahc25">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/ee6b71ba-e15b-42d0-ba5e-6294da9250ca.jpg" alt="LE PIAN DISTRIBUTION" className="h-8 w-auto sm:h-9" data-id="element-250" data-mp="2rlrjpg6fbp1h" />
    </a>;
}
export function Header({
  activeCategory,
  onCategorySelect,
  onAboutSelect
}: HeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleCategorySelection = (categoryKey: CategoryKey, subcategory?: string) => {
    onCategorySelect(categoryKey, subcategory);
    setMobileOpen(false);
  };
  const handleAboutSelection = () => {
    onAboutSelect();
    setMobileOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full bg-ardis-green shadow-sm" data-id="element-251" data-mp="30n7rrh9rnf2j">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-8" data-id="element-252" data-mp="1w5zp0lae5rn">
        <Logo data-id="element-253" data-mp="3tb3kkaw7smu1" />

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navigation principale" data-id="element-254" data-mp="3talhovf1rad5">
          <a href="#accueil" className="rounded-md px-3.5 py-2 text-sm font-semibold text-white transition-colors hover:text-ardis-yellow" data-id="element-255" data-mp="1rd1kmx1omnjw">
            Accueil
          </a>
          <button type="button" onClick={handleAboutSelection} className="rounded-md px-3.5 py-2 text-sm font-semibold text-white transition-colors hover:text-ardis-yellow focus:outline-none focus:ring-2 focus:ring-ardis-yellow focus:ring-offset-2 focus:ring-offset-ardis-green" data-id="element-256" data-mp="1weh8ewv8v85z">
            À propos de Nous
          </button>
          {CATEGORY_NAV_ITEMS.map(item => <div key={item.key} className="group relative" data-id="element-257" data-mp="ypfg9mkmrevz">
              <button type="button" onClick={() => handleCategorySelection(item.key)} aria-current={activeCategory === item.key ? 'page' : undefined} className={`flex items-center gap-1 rounded-md px-3.5 py-2 text-sm font-semibold transition-colors ${activeCategory === item.key ? 'text-ardis-yellow' : 'text-white hover:text-ardis-yellow'}`} data-id="element-258" data-mp="yr0djjybxbxj">
                {item.label}
                {item.children && <ChevronDownIcon className="h-3.5 w-3.5 transition-transform group-hover:rotate-180" data-id="element-259" data-mp="hdqnqsp3clkg" />}
              </button>
              {item.children && <div className="invisible absolute left-0 top-full w-56 translate-y-1 rounded-lg border border-black/5 bg-white py-2 opacity-0 shadow-xl transition-all duration-150 group-within:visible group-within:translate-y-0 group-within:opacity-100 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100" data-id="element-260" data-mp="rczhpljyi06t">
                  {item.children.map(child => <button key={child} type="button" onClick={() => handleCategorySelection(item.key, child)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 transition-colors hover:bg-ardis-green/5 hover:text-ardis-green focus:bg-ardis-green/5 focus:text-ardis-green focus:outline-none" data-id="element-261" data-mp="1a3zbd02eby6f">
                      {child}
                    </button>)}
                </div>}
            </div>)}
        </nav>

        <button type="button" className="rounded-md p-1.5 text-white lg:hidden" onClick={() => setMobileOpen(open => !open)} aria-label={mobileOpen ? 'Fermer le menu' : 'Ouvrir le menu'} aria-expanded={mobileOpen} data-id="element-262" data-mp="2gy6jrn4lwsde">
          {mobileOpen ? <XIcon className="h-6 w-6" data-id="element-263" data-mp="1t8vryv58i8be" /> : <MenuIcon className="h-6 w-6" data-id="element-264" data-mp="1t8lwis1f78yb" />}
        </button>
      </div>

      {mobileOpen && <nav className="border-t border-white/10 bg-ardis-green-dark px-4 py-3 lg:hidden" aria-label="Navigation mobile" data-id="element-265" data-mp="1xzu89uq836en">
          <a href="#accueil" onClick={() => setMobileOpen(false)} className="block rounded-md px-3 py-2.5 text-sm font-semibold text-white" data-id="element-266" data-mp="11gwntlhxvz7o">
            Accueil
          </a>
          <button type="button" onClick={handleAboutSelection} className="block w-full rounded-md px-3 py-2.5 text-left text-sm font-semibold text-white hover:text-ardis-yellow" data-id="element-267" data-mp="y00i8b4mdocr">
            À propos de Nous
          </button>
          {CATEGORY_NAV_ITEMS.map(item => <div key={item.key} data-id="element-268" data-mp="jzzfeq4so6un">
              <button type="button" onClick={() => handleCategorySelection(item.key)} className={`flex w-full items-center justify-between rounded-md px-3 py-2.5 text-left text-sm font-semibold ${activeCategory === item.key ? 'text-ardis-yellow' : 'text-white'}`} data-id="element-269" data-mp="jyxvdw5swa0s">
                {item.label}
                {item.children && <ChevronDownIcon className="h-4 w-4" data-id="element-270" data-mp="1assss0vqv3k" />}
              </button>
              {item.children?.map(child => <button key={child} type="button" onClick={() => handleCategorySelection(item.key, child)} className="block w-full px-7 py-2 text-left text-sm text-white/75 hover:text-ardis-yellow" data-id="element-271" data-mp="3shvkrlojl5eu">
                  {child}
                </button>)}
            </div>)}
        </nav>}
    </header>;
}